/* This file is autogenerated, see readme.md for instructions */
import AppleSvgIcon from '@bloomreach/banana-theme/icons/apple.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const AppleIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <AppleSvgIcon />
    </Icon>
  );
});

AppleIcon.displayName = 'AppleIcon';

export default AppleIcon;
